import React from 'react';
import StoreDownloadCta from './StoreDownloadCta';
import './HomeDownloadSection.css';

/**
 * Public homepage app download block. Destinations come from appLinks via
 * StoreDownloadCta, so an unset store stays Coming Soon.
 */
const HomeDownloadSection: React.FC = () => {
  return (
    <section className="home-download" aria-labelledby="home-download-heading">
      <div className="home-download__inner">
        <p className="home-download__eyebrow">Get the app</p>
        <h2 id="home-download-heading" className="home-download__title">
          Download LookBel
        </h2>
        <p className="home-download__text">
          Book beauty and wellness services wherever you are.
        </p>
        <div className="home-download__actions">
          <StoreDownloadCta store="ios" variant="modal" />
          <StoreDownloadCta store="android" variant="modal" />
        </div>
      </div>
    </section>
  );
};

export default HomeDownloadSection;
